import { render, staticRenderFns } from "./alarmesetalertes.vue?vue&type=template&id=06b0ccf6&scoped=true"
import script from "./alarmesetalertes.vue?vue&type=script&lang=js"
export * from "./alarmesetalertes.vue?vue&type=script&lang=js"
import style0 from "./alarmesetalertes.vue?vue&type=style&index=0&id=06b0ccf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b0ccf6",
  null
  
)

export default component.exports